import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box} from 'views/components';
import {Translate, translate} from 'views/module';

import PillDropdown from 'views/scenes/client_lead/list/scene/list/dropdowns/PillDropdown';
import {StageReasonDialog, useStageChange} from 'views/scenes/loom_lead/stage';

const StageDropdown = (props) => {
  const {clientId, leadQuality, selectedStage, onChanged, onOverlayChange} = props;
  const progressWrap = props.statusProgressWrap;

  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const {pendingStage, selectStage, saveReason, closeReason} = useStageChange({
    clientId,
    selectedStage,
    onChanged,
    progressWrap,
  });

  // The card is a link, so it must not navigate while the menu or the dialog is open.
  React.useEffect(() => {
    onOverlayChange(isMenuOpen || !!pendingStage);
  }, [isMenuOpen, pendingStage, onOverlayChange]);

  const stages = Object.entries(translate('loomLead.Status'));
  const stageData = translate(`loomLead.Status.${selectedStage}`);
  const leadQualityColor = leadQuality && translate(`loomLead.LeadQuality.${leadQuality}.Color`);

  return (
    <>
      <PillDropdown
        backgroundColor={stageData.Color || 'transparent'}
        borderColor={stageData.ColorBorder || stageData.Color || 'transparent'}
        label={
          <Box sx={{display: 'inline-flex', alignItems: 'center', gap: '6px'}}>
            {
              leadQualityColor &&
              <Box
                sx={{
                  width: '8px',
                  height: '8px',
                  borderRadius: '50%',
                  backgroundColor: leadQualityColor,
                  flexShrink: 0,
                }}
              />
            }
            <Translate expression={`loomLead.Status.${selectedStage}.Title`} />
          </Box>
        }
        menuLabel={translate('loomLead.LoomLeadDetail.Header.Menu.Subtitles.Stage')}
        onOpenChange={setIsMenuOpen}
        onOptionSelect={selectStage}
        options={stages}
        selectedValue={selectedStage}
        textColor={stageData.ColorText || '#000000'}
      />
      {
        pendingStage &&
        <StageReasonDialog stage={pendingStage} onClose={closeReason} onSave={saveReason} />
      }
    </>
  );
};

StageDropdown.propTypes = {
  clientId: PropTypes.string.isRequired,
  leadQuality: PropTypes.string,
  selectedStage: PropTypes.string.isRequired,
  onChanged: PropTypes.func.isRequired,
  onOverlayChange: PropTypes.func.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(StageDropdown));
